import api from './Api';

export interface ConciliadoBancarioItem {
    extratoId: number;
    dataExtrato: string | null;
    historicoExtrato: string | null;
    valorExtrato: number;
    tipoExtrato: string;
    lancamentoId: number | null;
    dataLancamento: string | null;
    historicoLancamento: string | null;
    valorLancamento: number | null;
    tipoLancamento: string | null;
}

export interface ConciliadosBancariosResponse {
    items: ConciliadoBancarioItem[];
    total: number;
    page: number;
    perPage: number;
}

export interface ExtratoBancarioPendente {
    id: number;
    tipo: string;
    valor: number;
    historico: string | null;
    dataLancamento: string | null;
    status: string;
}

export interface ExtratosPendentesResponse {
    items: ExtratoBancarioPendente[];
    total: number;
    totalPages: number;
    page: number;
    perPage: number;
}

export interface VincularExtratoBancarioResponse {
    chaveVinculo: string;
    totalRazao: number;
    totalExtrato: number;
    diferenca: number;
    porcentagem: number;
}

const ExtratoBancarioService = {
    listarPendentes: async (
        esteiraId: number,
        cartaoId: number,
        page: number = 1,
        perPage: number = 20,
        filtro?: { ano?: number; mes?: number; dia?: number; historico?: string; valor?: number }
    ): Promise<ExtratosPendentesResponse> => {
        const { data } = await api.get<ExtratosPendentesResponse>(`ExtratoBancario/${esteiraId}/${cartaoId}/pendentes`, {
            params: {
                page,
                perPage,
                ...(filtro?.ano ? { ano: filtro.ano } : {}),
                ...(filtro?.mes ? { mes: filtro.mes } : {}),
                ...(filtro?.dia ? { dia: filtro.dia } : {}),
                ...(filtro?.historico ? { historico: filtro.historico } : {}),
                ...(filtro?.valor !== undefined && !isNaN(filtro.valor) ? { valor: filtro.valor } : {}),
            }
        });
        return data;
    },

    vincular: async (
        esteiraId: number,
        cartaoId: number,
        lancamentoIds: number[],
        extratoIds: number[]
    ): Promise<VincularExtratoBancarioResponse> => {
        const { data } = await api.post<VincularExtratoBancarioResponse>('ExtratoBancario/vincular', { esteiraId, cartaoId, lancamentoIds, extratoIds });
        return data;
    },


    iniciarProcessamento: async (esteiraId: number, cartaoId: number): Promise<void> => {
        await api.post('ExtratoBancario/iniciar', { esteiraId, cartaoId });
    },

    excluirExtratos: async (esteiraId: number, cartaoId: number, arquivoOperacaoIds: number[]): Promise<void> => {
        await api.post('ExtratoBancario/excluir', { esteiraId, cartaoId, arquivoOperacaoIds });
    },

    // DEVN3-686 — extrato em PDF: decisão depois da previsão de custo da IA.
    decidirPdf: async (arquivoOperacaoId: number, processar: boolean): Promise<void> => {
        await api.post('ExtratoBancario/pdf/decidir', { arquivoOperacaoId, processar });
    },

    // DEVN3-686 — leitura que não fechou com os saldos do PDF (ou sem saldo para conferir).
    confirmarPdf: async (arquivoOperacaoId: number, acao: 'IMPORTAR' | 'RELER' | 'DESCARTAR'): Promise<void> => {
        await api.post('ExtratoBancario/pdf/confirmar', { arquivoOperacaoId, acao });
    },

    getConciliados: async (
        cartaoId: number,
        page: number = 1,
        perPage: number = 20,
        filtro?: string
    ): Promise<ConciliadosBancariosResponse> => {
        const params = new URLSearchParams({ cartaoId: String(cartaoId), page: String(page), perPage: String(perPage) });
        if (filtro) params.append('filtro', filtro);
        const resp = await api.get(`ExtratoBancario/conciliados?${params.toString()}`);
        return resp.data;
    }
};

export default ExtratoBancarioService;
